import { render, staticRenderFns } from "./updateInventory.vue?vue&type=template&id=553ed3d8&scoped=true&"
import script from "./updateInventory.vue?vue&type=script&lang=ts&"
export * from "./updateInventory.vue?vue&type=script&lang=ts&"
import style0 from "./updateInventory.vue?vue&type=style&index=0&id=553ed3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ed3d8",
  null
  
)

export default component.exports